import type { StartImportJobApiProps } from '../../../@types/background-jobs';
import i18next from '../../../i18n';
import type { ImportConfiguration } from './configuration-section';

interface Payload extends Omit<StartImportJobApiProps, 'id'> {}

export const transformConfigurationData = (data?: ImportConfiguration) => {
  const payload: Payload = {};
  for (const property in data) {
    switch (property) {
      case 'timeZone':
        payload['time_zone'] = data[property].value as string;
        break;
      case 'optionsImportMode':
        payload['options_import_mode'] = data[property].value as number;
        break;
      case 'sendRecordNotifications':
        payload['send_record_notifications'] = data[property] ? String(data[property]?.checked) : undefined;
        break;
    }
  }
  return payload;
};

export const errorhandlingOptions = [
  {
    value: 0,
    text: i18next.t('do-not-import-record-warn'),
  },
  { value: 1, text: i18next.t('import-record-and-leave-field-blank') },
  {
    value: 2,
    text: i18next.t('import-record-and-autocreate-unrecognized-options'),
  },
  {
    value: 3,
    text: i18next.t('import-record-and-autocreate-and-archive-unrecognized-options'),
  },
];

export const templateHelpMessage = () => {
  return (
    `${i18next.t('import-records-template-tooltip-1')} <br><br>` +
    `${i18next.t('import-records-template-tooltip-2')} <br><br>` +
    `${i18next.t('import-records-template-tooltip-3')} <br><br>` +
    `${i18next.t('import-records-template-tooltip-4')} <br><br>` +
    i18next.t('import-records-template-tooltip-5')
  );
};

export const configurationHelpMessage = () => {
  return `<b>${i18next.t('error-handling')}</b>: ${i18next.t('import-records-configuration-tooltip')}`;
};

export const unrecognisedOptionHelpText = () => {
  return `<p>${i18next.t('option-does-not-apply-to-fields')}</p><ul class="list-disc pl-5"><li>${i18next.t('competency-fields')}</li><li>${i18next.t('hierarchy-fields')}</li><li>${i18next.t('person-fields')}</li></ul>`;
};
